import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import WorkEducationView from '@/views/WorkEducationView.vue'
import SampleProjectsView from '@/views/SampleProjectsView.vue'
import ContactsView from '@/views/ContactsView.vue'
import EmailSentView from '@/views/EmailSentView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
  },
  {
    path: '/work-education',
    name: 'workeducation',
    component: WorkEducationView
  },
  {
    path:'/sample-projects',
    name:'sampleprojects',
    component: SampleProjectsView
  },
  {
    path:'/contacts',
    name:'contacts',
    component: ContactsView
  },
  {
    path:'/sent',
    name:'sent',
    component: EmailSentView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
